import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

// Accesos rápidos (solo mobile) a los filtros de paquetes: "Todos" + promociones/destaques
function MobileQuickMenu({ destaques = [] }) {
  const scrollRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(true);

  const items = [
    { key: 'todos', to: '/paquetes', label: 'Todos', icono: '🧳' },
    ...destaques.map(d => ({
      key: d.id,
      to: `/paquetes?destaque=${d.id}`,
      label: d.nombre,
      icono: d.icono || '🎯',
    })),
  ];

  const updateArrows = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    setCanLeft(el.scrollLeft > 8);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 8);
  }, []);

  useEffect(() => {
    updateArrows();
    window.addEventListener('resize', updateArrows);
    return () => window.removeEventListener('resize', updateArrows);
  }, [updateArrows, destaques]);

  const scrollBy = (dir) => {
    scrollRef.current?.scrollBy({ left: dir * 200, behavior: 'smooth' });
  };

  return (
    <div className="md:hidden relative z-[90] px-2">
      {canLeft && (
        <button
          type="button"
          aria-label="Anterior"
          onClick={() => scrollBy(-1)}
          className="absolute left-0 top-5 z-10 text-white drop-shadow"
        >
          <ChevronLeft size={26} />
        </button>
      )}
      <div
        ref={scrollRef}
        onScroll={updateArrows}
        className="flex gap-4 overflow-x-auto px-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {items.map(({ key, to, label, icono }) => (
          <Link
            key={key}
            to={to}
            className="flex flex-col items-center flex-shrink-0 w-[76px] text-white"
          >
            <span className="flex items-center justify-center w-14 h-14 rounded-full border-2 border-white bg-black/25 backdrop-blur-sm text-2xl">
              <span className="[filter:brightness(0)_invert(1)]">{icono}</span>
            </span>
            <span className="mt-1 text-xs font-medium text-center leading-tight drop-shadow line-clamp-2">{label}</span>
          </Link>
        ))}
      </div>
      {canRight && (
        <button
          type="button"
          aria-label="Siguiente"
          onClick={() => scrollBy(1)}
          className="absolute right-0 top-5 z-10 text-white drop-shadow"
        >
          <ChevronRight size={26} />
        </button>
      )}
    </div>
  );
}

export default MobileQuickMenu;
